// import React, { useState } from "react";
import Banner from "../Components/Banner/Banner";
import Portfolio from "../Components/Portfolio/Portfolio";
import Header from "../Header/Header";

import { useSection } from "../Components/utils/SectionContext/SectionContext";
const Main = () => {
  const { activeSection } = useSection();
  return (
    <div className="main">
      <Header />

      {activeSection === "banners" ? <Banner /> : <Portfolio />}
    </div>
  );
};

export default Main;
